"use client";

/**
 * Not sure about the background, but we were informed that the business decided
 * that all of these messages must remain, on a randomised basis:
 *
 * https://itdoc.redbull.com/display/CSM/2025-05-09+Weekly+update
 */

export const RandomFrenchHealthWarning = () => {
  const possibleMessages = [
    "Pour votre santé, mangez au moins cinq fruits et légumes par jour.",
    "Pour votre santé, pratiquez une activité physique régulière.",
    "Pour votre santé, évitez de manger trop gras, trop sucré, trop salé.",
    "Pour votre santé, évitez de grignoter entre les repas.",
  ];
  return (
    <span suppressHydrationWarning>
      {possibleMessages[Math.floor(Math.random() * possibleMessages.length)]}
    </span>
  );
};
